import { useState } from "react";
import { X, Wallet as WalletIcon, CreditCard, Landmark } from "lucide-react";

const quickAmounts = [1000, 5000, 10000, 25000];
const methods = [
  { id: "upi", label: "UPI", icon: WalletIcon },
  { id: "card", label: "Card", icon: CreditCard },
  { id: "netbanking", label: "Net Banking", icon: Landmark },
];

export default function AddMoneyModal({ onClose, onConfirm }) {
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("upi");

  const handleConfirm = () => {
    const value = Number(amount);
    if (!value || value <= 0) return;
    onConfirm(value);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-5 right-5 text-gray-400 hover:text-gray-600"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-xl font-extrabold text-gray-900 mb-1">Add Money</h2>
        <p className="text-sm text-gray-500 mb-6">
          Top up your ProtoHub wallet to pay for quotations instantly.
        </p>

        <label className="block mb-4">
          <span className="block text-sm font-medium text-gray-700 mb-1.5">Amount</span>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 font-semibold">
              ₹
            </span>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="0"
              className="w-full border border-gray-200 rounded-xl pl-8 pr-4 py-2.5 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </div>
        </label>

        <div className="flex flex-wrap gap-2 mb-6">
          {quickAmounts.map((amt) => (
            <button
              key={amt}
              type="button"
              onClick={() => setAmount(String(amt))}
              className="text-sm font-medium border border-gray-200 rounded-full px-4 py-1.5 hover:border-indigo-300 transition"
            >
              ₹{amt.toLocaleString("en-IN")}
            </button>
          ))}
        </div>

        <p className="text-sm font-medium text-gray-700 mb-2">Payment Method</p>
        <div className="grid grid-cols-3 gap-3 mb-6">
          {methods.map(({ id, label, icon: Icon }) => {
            const isSelected = method === id;
            return (
              <button
                key={id}
                type="button"
                onClick={() => setMethod(id)}
                className={`flex flex-col items-center gap-2 rounded-xl border py-3 text-xs font-semibold transition ${
                  isSelected
                    ? "border-indigo-500 bg-indigo-50 text-indigo-700"
                    : "border-gray-200 text-gray-600 hover:border-indigo-300"
                }`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </button>
            );
          })}
        </div>

        <button
          type="button"
          onClick={handleConfirm}
          className="w-full bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold text-sm py-3 rounded-xl hover:opacity-90 transition"
        >
          Add ₹{amount ? Number(amount).toLocaleString("en-IN") : "0"} to Wallet
        </button>
      </div>
    </div>
  );
}